<template>
    <div>

        <a-upload-dragger name="file" :multiple="true" action="https://www.mocky.io/v2/5cc8019d300000980a055e76" @change="handleChange">
            <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">Clic aquí o arrastre archivo aqui.</p>
            <p class="ant-upload-hint">Soporta archivos .jpg, .png</p>
        </a-upload-dragger>

       <a-divider dashed/>

        <a-list :grid="{ gutter: 16, xs: 3, sm: 2, md: 4, lg: 3, xl: 3, xxl: 3 }"   :dataSource="folder.childrens || files">
            <a-list-item slot="renderItem" slot-scope="item">
                <a-card hoverable :bodyStyle="{padding:0, textAlign:'center'}"  @click="showDrawer(item)"  :headStyle="{border:'none'}" :bordered="false"  >
                    <img slot="extra" :src="item.imageUrl" class="img-fluid" alt="">
                    {{item.name}}
                </a-card>
            </a-list-item>
        </a-list>

    </div>
</template>

<script>
export default {
  name: 'folderDetails',
  props: ['folder'],
  data() {
    return {
      files: [],
    }
  },

  //   computed:{
  //       files: function(){
  //           return []
  //       }
  //   },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        console.log(info.file)

        // Get this url from response in real world.
        this.getBase64(info.file.originFileObj).then((imageUrl) => {
          // console.log(imageUrl)
          this.imageUrl = imageUrl
          this.loading = false
        })
        // this.getBase64(info.file.originFileObj, (imageUrl) => {
        // this.imageUrl = imageUrl
        // this.loading = false
        // })
      }
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      if (!isJPG) {
        this.$message.error('You can only upload JPG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
      }
      return isJPG && isLt2M
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
  },
}
</script>

<style>
    /* .ant-upload.ant-upload-drag{
        height: 120px;
    } */
</style>
